import { Button } from '@pandiafi/design-system'
import { StatusView } from '@pandiafi/components'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

interface SuccessProps {
  illustration: React.ReactNode
  heading?: string
  text?: string
  buttonAction?: () => void
  buttonText?: string
}

/**
 * A sent form or a finished action. Focus moves to the heading so keyboard
 * and screen reader users land on the result.
 */
const Success: React.FC<SuccessProps> = ({
  illustration,
  heading,
  text,
  buttonAction,
  buttonText,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const navigate = useNavigate()
  const { frontPagePath } = useContractPaths()

  return (
    <StatusView
      variant="success"
      title={heading ?? text}
      illustration={illustration}
      action={
        <Button
          type="button"
          variant="primary"
          onClick={() =>
            buttonAction
              ? buttonAction()
              : navigate(frontPagePath, { replace: true })
          }
        >
          {buttonText || t('common:backToHome')}
        </Button>
      }
    >
      {heading && text}
    </StatusView>
  )
}

export default Success
